import objectPath from 'object-path'
import { getForm } from './Design'
import { getCurrentUi } from './Data'
import { CONDITION_GROUP } from './Option'
import cloneDeep from 'clone-deep'
import { getOptionData } from './Dropdown'

export const createFormComponentInputOption = (jsonForm, formComponentUi) => {
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}
  let mapFormData = objectPath.get(jsonForm, 'schema.mapFormData') || {}
  let mapDynamic = objectPath.get(jsonForm, 'schema.mapDynamic') || {}
  let orderMapNames = Object.keys(mapName)
  if (!formComponentUi.key) return []
  orderMapNames.sort((aKey, bKey) => mapName[aKey].localeCompare(mapName[bKey]))
  let filterForm =
    orderMapNames.filter((key) => {
      if (objectPath.get(mapFormData, key) || objectPath.get(mapDynamic, key))
        return true
      return false
    }) || []
  let options = []
  filterForm.map((key) => {
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui?.key !== key) return
    let label = objectPath.get(mapName, key)
    let layout = label.split('.').shift()
    let fullKey = objectPath.get(mapKey, key)
    let keys = (fullKey && fullKey.split('.')) || []
    let fieldName = []
    let nameList = [layout]
    keys.shift()
    keys.forEach((key) => {
      let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
      if (ui.tagname === 'checkboxGroup') {
        if (ui.key === key) {
          fieldName.push(ui.fieldName)
          nameList.push(ui.name)
        } else {
          let { options = [] } = ui
          let foundOption = options.find((option) => option.key === key)
          if (foundOption) {
            let { label, name } = foundOption
            fieldName.push(label)
            nameList.push(name)
          }
        }
      } else if (ui.fieldName) {
        fieldName.push(ui.fieldName)
        nameList.push(ui.name)
      } else {
        fieldName.push(ui.name)
        nameList.push(ui.name)
      }
    })
    let fullName = nameList.join('.')
    let shortName = ui.name
    fieldName = fieldName.join(' > ')
    let data = {}
    data = {
      ...data,
      groupType: layout,
      groupIndex: CONDITION_GROUP[layout],
      label: `${formComponentUi.fieldName} | ${fieldName} | ${shortName}`,
      name: fullName,
      fieldName: ui.fieldName,
      isDynamic: objectPath.get(mapDynamic, key),
      isInsideDynamic: ui.isInsideDynamic,
      dynamicName: shortName,
      fullKey: objectPath.get(mapKey, key),
      tagname: ui.tagname,
      key: key,
      value: shortName,
      isFormComponent: true,
      optionKey: key,
      optionName: shortName,
      formComponentKey: formComponentUi.key,
      formComponentName: formComponentUi.name,
      ui,
    }
    options.push(data)
  })
  return options
}

export const createFormComponent = async (designContext, data) => {
  let { jsonForm, isUiChanged, setIsUiChanged, setFormData } = designContext
  let formData = jsonForm.formData
  let { pathParams, queryParams, location } = data
  let { loadForm } = jsonForm
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}
  if (!loadForm) return
  let promiseList = []
  let tabFormOption = []
  let tabFormGroup = []
  let formComponentUiList = {}
  let filterForm = Object.keys(loadForm).filter((key) => {
    let code = loadForm[key]
    let formComponentUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    let isSameCode = formComponentUi?.loadForm?.formCode === code
    if (isSameCode) {
      objectPath.set(formComponentUiList, key, formComponentUi)
    }
    return isSameCode
  })
  filterForm.forEach((key) => {
    let promise = (async () => {
      let code = loadForm[key]
      let formComponentUi = formComponentUiList[key]
      let allForm = await Promise.all(promiseList)
      let foundForm = allForm.find((form) => form?.formDesign?.code === code)
      if (foundForm) return { ...foundForm, formComponentUi }
      let useFormData = true
      let tabForm = await getForm(
        code,
        pathParams,
        queryParams,
        location,
        useFormData,
        {},
        datasourceValue
      )
      let option = createFormComponentInputOption(
        tabForm.jsonForm,
        formComponentUi
      )
      let selectOption = option.filter(({ tagname }) => tagname === 'select')
      let optionPromiseList = selectOption.map((option) => {
        let uischema = option.ui
        let { formComponentName } = option
        let key = uischema.key
        return getOptionData({
          uischema,
          designContext,
          key,
          data,
          propSelect: { isFetchOption: false, isCallOption: true },
          formComponentName,
        }).catch((error) => console.error('There was an error!', error))
      })
      await Promise.all(optionPromiseList)
      return { ...tabForm, formComponentUi, option }
    })()
    promiseList.push(promise)
  })
  await Promise.all(promiseList).then((resolveData) => {
    resolveData.forEach((tabForm) => {
      if (!tabForm) return
      let { jsonForm, formDesign, datasource, formComponentUi, option } =
        tabForm
      let name = formComponentUi.name
      objectPath.set(isUiChanged, ['tabForm', name], {
        jsonForm,
        formDesign,
      })
      tabFormOption = [...tabFormOption, ...option]
      objectPath.set(isUiChanged, 'tabFormOption', tabFormOption)
      let formGroup = jsonForm?.formGroup || []
      formGroup.forEach((group) => {
        let item = cloneDeep(group)
        item.formDataName = `${formComponentUi.fieldName} | ${group.formDataName}`
        item.key = `${formComponentUi.key}-${group.key}`
        item.formComponentName = name
        item.isFormComponent = true
        tabFormGroup.push(item)
        if (objectPath.get(formData, item.key)) {
          let data = objectPath.get(formData, item.key)
          let oldData = objectPath.get(formData, name) || {}
          objectPath.set(formData, name, {
            ...oldData,
            ...data,
          })
        }
      })
      objectPath.set(isUiChanged, 'tabFormGroup', tabFormGroup)
      setIsUiChanged(isUiChanged)
      setFormData(formData)
    })
  })
}
